import React from "react"
import useMediaQuery from "../../../shared/utils/useMediaQuery.js"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal.jsx"
import ReactPlayer from "react-player"

import "./modal-player.scss"

export default function ModalPlayer({ src = "", setModal }) {
  const isMobile = useMediaQuery()
  const handleCloseModalVideo = () => {
    setModal()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "Interacciones - Video",
      category: "cole challenge",
      action: "click",
      label: `${durationVideoWatched}`,
    })
  }
  let durationVideoWatched 

  return (
    <GenericModal background={"transparent"}>
      <div className="f-modal-player">
        <div className="f-modal-player-container-btn">
          <button
            className="f-modal-player--btn-close"
            onClick={handleCloseModalVideo}
          >
            X
          </button>
        </div>
        <div className="f-modal-player-container-iframe">
          <ReactPlayer
            className="f-section-banner__video"
            width="100%"
            height="auto"
            url={src}
            controls
            onProgress={({ playedSeconds }) => {
              durationVideoWatched = playedSeconds
            }}
          />
        </div>
      </div>
    </GenericModal>
  )
}
